import { type InitOptions } from "i18next";

/**
 * Shared i18n configuration between server and client
 */
export const I18N_CONFIG: InitOptions = {
  fallbackLng: ["en"],
  defaultNS: "content",
  fallbackNS: "content",
  ns: ["common", "content", "customTerms"],
  initAsync: false,
  initImmediate: true,
  interpolation: {
    escapeValue: false, // React already escapes for us.
  },
  react: {
    useSuspense: false,
  },
} as const;
